import React, { forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const FacetFacNegative = forwardRef((props, ref) => (
  <SvgIcon viewBox="0 0 90.5 90" {...props} ref={ref}>
    <rect x="-267.9" y="-28.5" fill="none" />
    <polygon fill="#FF9100" points="45.3,0 0,45 45.3,90 90.5,45" />
  </SvgIcon>
));

export default FacetFacNegative;
